import React from "react";
export default function Crypto() {
  return <div className="adminPortalContainer"><h2>Crypto</h2></div>;
}